// Mock data for Financial Management subsystems
// This file contains structured data for Cash Management, Budget Planning, and Cash Flow Forecast
// Following systematic naming conventions for future Supabase migration

export const cashManagementData = {
  // Cash accounts with balances and transaction history
  cashAccounts: [
    {
      account_id: "cash-001",
      account_name: "營運現金帳戶",
      account_type: "operating",
      currency: "HKD",
      current_balance: 1250000.00,
      available_balance: 1235000.00,
      last_updated: "2025-07-04T18:30:00",
      bank_name: "香港匯豐銀行",
      account_number: "**** **** 3456",
      status: "active"
    },
    {
      account_id: "cash-002",
      account_name: "資本支出帳戶",
      account_type: "capital",
      currency: "HKD",
      current_balance: 3500000.00,
      available_balance: 3500000.00,
      last_updated: "2025-07-04T18:30:00",
      bank_name: "香港匯豐銀行",
      account_number: "**** **** 7890",
      status: "active"
    },
    {
      account_id: "cash-003",
      account_name: "美元儲備帳戶",
      account_type: "reserve",
      currency: "USD",
      current_balance: 500000.00,
      available_balance: 500000.00,
      last_updated: "2025-07-04T18:30:00",
      bank_name: "花旗銀行",
      account_number: "**** **** 1234",
      status: "active"
    },
    {
      account_id: "cash-004",
      account_name: "應急資金帳戶",
      account_type: "emergency",
      currency: "HKD",
      current_balance: 750000.00,
      available_balance: 750000.00,
      last_updated: "2025-07-04T18:30:00",
      bank_name: "中國銀行",
      account_number: "**** **** 5678",
      status: "active"
    },
    {
      account_id: "cash-005",
      account_name: "人民幣業務帳戶",
      account_type: "operating",
      currency: "CNY",
      current_balance: 2500000.00,
      available_balance: 2500000.00,
      last_updated: "2025-07-04T18:30:00",
      bank_name: "中國工商銀行",
      account_number: "**** **** 9012",
      status: "active"
    },
    {
      account_id: "cash-006",
      account_name: "歐元業務帳戶",
      account_type: "operating",
      currency: "EUR",
      current_balance: 180000.00,
      available_balance: 180000.00,
      last_updated: "2025-07-04T18:30:00",
      bank_name: "渣打銀行",
      account_number: "**** **** 3456",
      status: "active"
    },
    {
      account_id: "cash-007",
      account_name: "定期存款帳戶",
      account_type: "term_deposit",
      currency: "HKD",
      current_balance: 5000000.00,
      available_balance: 0.00,
      last_updated: "2025-07-04T18:30:00",
      bank_name: "香港匯豐銀行",
      account_number: "**** **** 7890",
      status: "locked",
      maturity_date: "2025-12-31",
      interest_rate: 3.5
    },
    {
      account_id: "cash-005",
      account_name: "人民幣業務帳戶",
      account_type: "operating",
      currency: "CNY",
      current_balance: 2000000.00,
      available_balance: 1980000.00,
      last_updated: "2025-07-04T18:30:00",
      bank_name: "中國工商銀行",
      account_number: "**** **** 9012",
      status: "active"
    }
  ],

  // Recent transactions
  recentTransactions: [
    {
      transaction_id: "trx-00123",
      account_id: "cash-001",
      transaction_date: "2025-07-04T15:30:00",
      amount: -45000.00,
      currency: "HKD",
      description: "供應商付款 - 廣州電子有限公司",
      category: "supplier_payment",
      reference: "INV-GZ-2025-0723",
      status: "completed"
    },
    {
      transaction_id: "trx-00124",
      account_id: "cash-001",
      transaction_date: "2025-07-04T14:15:00",
      amount: 120000.00,
      currency: "HKD",
      description: "客戶付款 - 香港零售集團",
      category: "customer_payment",
      reference: "INV-HK-2025-0156",
      status: "completed"
    },
    {
      transaction_id: "trx-00125",
      account_id: "cash-003",
      transaction_date: "2025-07-04T10:45:00",
      amount: -25000.00,
      currency: "USD",
      description: "國際供應商付款 - Global Tech Solutions",
      category: "supplier_payment",
      reference: "INV-GTS-2025-0089",
      status: "completed"
    },
    {
      transaction_id: "trx-00126",
      account_id: "cash-005",
      transaction_date: "2025-07-03T16:20:00",
      amount: 350000.00,
      currency: "CNY",
      description: "客戶付款 - 上海貿易有限公司",
      category: "customer_payment",
      reference: "INV-SH-2025-0042",
      status: "completed"
    },
    {
      transaction_id: "trx-00127",
      account_id: "cash-001",
      transaction_date: "2025-07-03T11:30:00",
      amount: -78500.00,
      currency: "HKD",
      description: "員工薪資支付 - 7月上半月",
      category: "payroll",
      reference: "PAY-2025-07-1",
      status: "completed"
    },
    {
      transaction_id: "trans-005",
      description: "支付辦公室租金",
      amount: -45000.00,
      currency: "HKD",
      transaction_date: "2025-07-01T09:30:00",
      account_id: "cash-001",
      category: "rent",
      reference: "INV-RENT-JUL2025",
      status: "completed"
    },
    {
      transaction_id: "trans-006",
      description: "收到客戶預付款",
      amount: 250000.00,
      currency: "HKD",
      transaction_date: "2025-07-05T10:15:00",
      account_id: "cash-001",
      category: "advance_payment",
      reference: "CUST-ADV-20250705",
      status: "completed"
    },
    {
      transaction_id: "trans-007",
      description: "支付供應商貨款",
      amount: -185000.00,
      currency: "HKD",
      transaction_date: "2025-07-05T11:30:00",
      account_id: "cash-001",
      category: "supplier_payment",
      reference: "PO-20250620-006",
      status: "pending"
    },
    {
      transaction_id: "trans-008",
      description: "收到銷售訂單付款",
      amount: 320000.00,
      currency: "HKD",
      transaction_date: "2025-07-05T14:20:00",
      account_id: "cash-001",
      category: "sales_revenue",
      reference: "SO-20250625-008",
      status: "completed"
    },
    {
      transaction_id: "trans-009",
      description: "人民幣兌換港幣",
      amount: 500000.00,
      currency: "HKD",
      transaction_date: "2025-07-05T15:45:00",
      account_id: "cash-001",
      category: "currency_exchange",
      reference: "FX-20250705-001",
      status: "completed"
    },
    {
      transaction_id: "trans-010",
      description: "人民幣兌換港幣",
      amount: -600000.00,
      currency: "CNY",
      transaction_date: "2025-07-05T15:45:00",
      account_id: "cash-005",
      category: "currency_exchange",
      reference: "FX-20250705-001",
      status: "completed"
    }
  ],

  // Scheduled payments
  scheduledPayments: [
    {
      payment_id: "pay-00234",
      account_id: "cash-001",
      scheduled_date: "2025-07-10",
      amount: 85000.00,
      currency: "HKD",
      recipient: "香港物業管理有限公司",
      description: "辦公室租金 - 7月",
      category: "rent",
      recurring: true,
      frequency: "monthly",
      status: "scheduled"
    },
    {
      payment_id: "sched-005",
      description: "季度保險費",
      amount: 35000.00,
      currency: "HKD",
      scheduled_date: "2025-07-15",
      account_id: "cash-001",
      recipient: "安聯保險",
      recurring: true,
      frequency: "quarterly",
      next_date: "2025-10-15"
    },
    {
      payment_id: "sched-006",
      description: "廠房設備維護費",
      amount: 28500.00,
      currency: "HKD",
      scheduled_date: "2025-07-20",
      account_id: "cash-001",
      recipient: "先進工業設備維護有限公司",
      recurring: true,
      frequency: "monthly",
      next_date: "2025-08-20"
    },
    {
      payment_id: "sched-007",
      description: "員工培訓費用",
      amount: 45000.00,
      currency: "HKD",
      scheduled_date: "2025-07-25",
      account_id: "cash-001",
      recipient: "香港管理學院",
      recurring: false
    },
    {
      payment_id: "sched-008",
      description: "歐洲供應商預付款",
      amount: 25000.00,
      currency: "EUR",
      scheduled_date: "2025-07-28",
      account_id: "cash-006",
      recipient: "Siemens AG",
      recurring: false
    },
    {
      payment_id: "sched-009",
      description: "中國供應商貨款",
      amount: 350000.00,
      currency: "CNY",
      scheduled_date: "2025-07-30",
      account_id: "cash-005",
      recipient: "深圳科技有限公司",
      recurring: false
    },
    {
      payment_id: "pay-00235",
      account_id: "cash-001",
      scheduled_date: "2025-07-15",
      amount: 78500.00,
      currency: "HKD",
      recipient: "員工薪資",
      description: "員工薪資支付 - 7月下半月",
      category: "payroll",
      recurring: true,
      frequency: "semi-monthly",
      status: "scheduled"
    }
  ],

  // Cash flow KPIs
  cashFlowKPIs: [
    {
      kpi_id: "cf-kpi-001",
      name: "現金周轉天數",
      current_value: 45,
      unit: "天",
      target_value: 50,
      previous_value: 48,
      trend: "improving",
      status: "good"
    },
    {
      kpi_id: "cf-kpi-002",
      name: "營運現金流",
      current_value: 850000,
      unit: "HKD",
      target_value: 800000,
      previous_value: 780000,
      trend: "improving",
      status: "excellent"
    },
    {
      kpi_id: "cf-kpi-003",
      name: "流動比率",
      current_value: 2.1,
      unit: "",
      target_value: 2.0,
      previous_value: 1.9,
      trend: "improving",
      status: "good"
    },
    {
      kpi_id: "cf-kpi-004",
      name: "現金緩衝天數",
      current_value: 65,
      unit: "天",
      target_value: 60,
      previous_value: 62,
      trend: "improving",
      status: "excellent"
    }
  ]
};

export const budgetPlanningData = {
  // Annual budget by department
  departmentalBudgets: [
    {
      budget_id: "budget-dept-001",
      department_id: "dept-001",
      department_name: "生產部門",
      fiscal_year: 2025,
      total_budget: 12500000.00,
      currency: "HKD",
      budget_used: 6250000.00,
      budget_remaining: 6250000.00,
      last_updated: "2025-07-01",
      status: "active"
    },
    {
      budget_id: "budget-dept-002",
      department_id: "dept-002",
      department_name: "研發部門",
      fiscal_year: 2025,
      total_budget: 8000000.00,
      currency: "HKD",
      budget_used: 3800000.00,
      budget_remaining: 4200000.00,
      last_updated: "2025-07-01",
      status: "active"
    },
    {
      budget_id: "budget-dept-003",
      department_id: "dept-003",
      department_name: "市場營銷",
      fiscal_year: 2025,
      total_budget: 5000000.00,
      currency: "HKD",
      budget_used: 2750000.00,
      budget_remaining: 2250000.00,
      last_updated: "2025-07-01",
      status: "active"
    },
    {
      budget_id: "budget-dept-004",
      department_id: "dept-004",
      department_name: "銷售部門",
      fiscal_year: 2025,
      total_budget: 3500000.00,
      currency: "HKD",
      budget_used: 1850000.00,
      budget_remaining: 1650000.00,
      last_updated: "2025-07-01",
      status: "active"
    },
    {
      budget_id: "budget-dept-005",
      department_id: "dept-005",
      department_name: "行政部門",
      fiscal_year: 2025,
      total_budget: 2000000.00,
      currency: "HKD",
      budget_used: 980000.00,
      budget_remaining: 1020000.00,
      last_updated: "2025-07-01",
      status: "active"
    },
    {
      budget_id: "budget-dept-006",
      department_id: "dept-006",
      department_name: "資訊科技部",
      fiscal_year: 2025,
      total_budget: 4500000.00,
      currency: "HKD",
      budget_used: 2350000.00,
      budget_remaining: 2150000.00,
      last_updated: "2025-07-01",
      status: "active"
    },
    {
      budget_id: "budget-dept-007",
      department_id: "dept-007",
      department_name: "人力資源部",
      fiscal_year: 2025,
      total_budget: 3200000.00,
      currency: "HKD",
      budget_used: 1580000.00,
      budget_remaining: 1620000.00,
      last_updated: "2025-07-01",
      status: "active"
    },
    {
      budget_id: "budget-dept-008",
      department_id: "dept-008",
      department_name: "品質控制部",
      fiscal_year: 2025,
      total_budget: 2800000.00,
      currency: "HKD",
      budget_used: 1250000.00,
      budget_remaining: 1550000.00,
      last_updated: "2025-07-01",
      status: "active"
    }
  ],

  // Budget by expense category
  expenseCategoryBudgets: [
    {
      category_id: "exp-cat-001",
      category_name: "人力資源",
      fiscal_year: 2025,
      total_budget: 15000000.00,
      currency: "HKD",
      budget_used: 7250000.00,
      budget_remaining: 7750000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-002",
      category_name: "原材料",
      fiscal_year: 2025,
      total_budget: 8500000.00,
      currency: "HKD",
      budget_used: 4100000.00,
      budget_remaining: 4400000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-003",
      category_name: "設備維護",
      fiscal_year: 2025,
      total_budget: 2500000.00,
      currency: "HKD",
      budget_used: 1200000.00,
      budget_remaining: 1300000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-004",
      category_name: "行銷推廣",
      fiscal_year: 2025,
      total_budget: 4500000.00,
      currency: "HKD",
      budget_used: 2350000.00,
      budget_remaining: 2150000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-005",
      category_name: "辦公設施",
      fiscal_year: 2025,
      total_budget: 1800000.00,
      currency: "HKD",
      budget_used: 850000.00,
      budget_remaining: 950000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-006",
      category_name: "資訊科技",
      fiscal_year: 2025,
      total_budget: 3500000.00,
      currency: "HKD",
      budget_used: 1850000.00,
      budget_remaining: 1650000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-007",
      category_name: "研發投資",
      fiscal_year: 2025,
      total_budget: 6000000.00,
      currency: "HKD",
      budget_used: 2800000.00,
      budget_remaining: 3200000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-008",
      category_name: "品質控制",
      fiscal_year: 2025,
      total_budget: 2200000.00,
      currency: "HKD",
      budget_used: 980000.00,
      budget_remaining: 1220000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-009",
      category_name: "品牌建設",
      fiscal_year: 2025,
      total_budget: 2800000.00,
      currency: "HKD",
      budget_used: 1350000.00,
      budget_remaining: 1450000.00,
      last_updated: "2025-07-01"
    },
    {
      category_id: "exp-cat-010",
      category_name: "專業培訓",
      fiscal_year: 2025,
      total_budget: 1200000.00,
      currency: "HKD",
      budget_used: 580000.00,
      budget_remaining: 620000.00,
      last_updated: "2025-07-01"
    }
  ],

  // Budget variance reports
  budgetVarianceReports: [
    {
      report_id: "bvr-001",
      report_name: "Q2 2025 預算差異分析",
      fiscal_period: "Q2 2025",
      generation_date: "2025-07-01",
      departments: [
        {
          department_id: "dept-001",
          department_name: "生產部門",
          planned_budget: 3125000.00,
          actual_spend: 3250000.00,
          variance_amount: -125000.00,
          variance_percentage: -4.0,
          status: "over-budget",
          notes: "原材料價格上漲導致預算超支"
        },
        {
          department_id: "dept-002",
          department_name: "研發部門",
          planned_budget: 2000000.00,
          actual_spend: 1850000.00,
          variance_amount: 150000.00,
          variance_percentage: 7.5,
          status: "under-budget",
          notes: "部分研發項目延期至Q3"
        },
        {
          department_id: "dept-003",
          department_name: "市場營銷",
          planned_budget: 1250000.00,
          actual_spend: 1350000.00,
          variance_amount: -100000.00,
          variance_percentage: -8.0,
          status: "over-budget",
          notes: "新產品發布活動額外支出"
        },
        {
          department_id: "dept-004",
          department_name: "銷售部門",
          planned_budget: 875000.00,
          actual_spend: 920000.00,
          variance_amount: -45000.00,
          variance_percentage: -5.1,
          status: "over-budget",
          notes: "客戶拜訪差旅費用增加"
        },
        {
          department_id: "dept-005",
          department_name: "行政部門",
          planned_budget: 500000.00,
          actual_spend: 480000.00,
          variance_amount: 20000.00,
          variance_percentage: 4.0,
          status: "under-budget",
          notes: "辦公用品成本節省"
        },
        {
          department_id: "dept-006",
          department_name: "資訊科技部",
          planned_budget: 1125000.00,
          actual_spend: 1180000.00,
          variance_amount: -55000.00,
          variance_percentage: -4.9,
          status: "over-budget",
          notes: "系統安全升級的額外成本"
        }
      ],
      summary: {
        total_planned: 8875000.00,
        total_actual: 9030000.00,
        total_variance_amount: -155000.00,
        total_variance_percentage: -1.75,
        overall_status: "slightly-over-budget"
      }
    },
    {
      report_id: "bvr-002",
      report_name: "Q1 2025 預算差異分析",
      fiscal_period: "Q1 2025",
      generation_date: "2025-04-01",
      departments: [
        {
          department_id: "dept-001",
          department_name: "生產部門",
          planned_budget: 3125000.00,
          actual_spend: 3050000.00,
          variance_amount: 75000.00,
          variance_percentage: 2.4,
          status: "under-budget",
          notes: "生產效率提升導致成本降低"
        },
        {
          department_id: "dept-002",
          department_name: "研發部門",
          planned_budget: 2000000.00,
          actual_spend: 2050000.00,
          variance_amount: -50000.00,
          variance_percentage: -2.5,
          status: "slightly-over-budget",
          notes: "新研發項目前期投入"
        },
        {
          department_id: "dept-003",
          department_name: "市場營銷",
          planned_budget: 1250000.00,
          actual_spend: 1200000.00,
          variance_amount: 50000.00,
          variance_percentage: 4.0,
          status: "under-budget",
          notes: "數位行銷策略效果超出預期"
        },
        {
          department_id: "dept-007",
          department_name: "人力資源部",
          planned_budget: 800000.00,
          actual_spend: 780000.00,
          variance_amount: 20000.00,
          variance_percentage: 2.5,
          status: "under-budget",
          notes: "線上培訓系統減少培訓支出"
        }
      ],
      summary: {
        total_planned: 7175000.00,
        total_actual: 7080000.00,
        total_variance_amount: 95000.00,
        total_variance_percentage: 1.32,
        overall_status: "under-budget"
      }
    }
  ],

  // Budget planning KPIs
  budgetKPIs: [
    {
      kpi_id: "budget-kpi-001",
      name: "預算執行率",
      current_value: 49.8,
      unit: "%",
      target_value: 50.0,
      previous_value: 48.5,
      trend: "stable",
      status: "good"
    },
    {
      kpi_id: "budget-kpi-002",
      name: "預算差異率",
      current_value: 0.24,
      unit: "%",
      target_value: 5.0,
      previous_value: 3.2,
      trend: "improving",
      status: "excellent"
    },
    {
      kpi_id: "budget-kpi-003",
      name: "資本支出執行率",
      current_value: 45.2,
      unit: "%",
      target_value: 50.0,
      previous_value: 42.8,
      trend: "improving",
      status: "good"
    },
    {
      kpi_id: "budget-kpi-004",
      name: "營運支出執行率",
      current_value: 52.3,
      unit: "%",
      target_value: 50.0,
      previous_value: 51.5,
      trend: "stable",
      status: "good"
    },
    {
      kpi_id: "budget-kpi-005",
      name: "研發投資比率",
      current_value: 12.5,
      unit: "%",
      target_value: 15.0,
      previous_value: 11.8,
      trend: "improving",
      status: "good"
    },
    {
      kpi_id: "budget-kpi-006",
      name: "預算管理效率",
      current_value: 92.3,
      unit: "%",
      target_value: 90.0,
      previous_value: 89.5,
      trend: "improving",
      status: "excellent"
    },
    {
      kpi_id: "budget-kpi-007",
      name: "部門預算遵守率",
      current_value: 85.7,
      unit: "%",
      target_value: 90.0,
      previous_value: 82.5,
      trend: "improving",
      status: "good"
    },
    {
      kpi_id: "budget-kpi-008",
      name: "成本節省率",
      current_value: 3.2,
      unit: "%",
      target_value: 5.0,
      previous_value: 2.8,
      trend: "improving",
      status: "good"
    }
  ]
};
